import React, { FC } from 'react';

import { Image as ImageComponent, Text, Container } from '@lglp/components';
import { SimpleCardContainer } from '@lglp/prismic-client';

import Arrow from '../../../Icons/Arrow';
import { LinkedComponent } from '../../../LinkedComponent';
import styles from './SimpleCardContainer.module.scss';

export const SimpleCardContainerSlice: FC<SimpleCardContainerProps> = ({
  data,
}) => {
  const { image, title, ctaLabel, ctaLink } = data;
  return (
    <Container className={[styles.container, 'not-icon-cards']}>
      <LinkedComponent
        link={ctaLink}
        className={[styles.linkContainer, 'animate-svg']}
      >
        <ImageComponent className={styles.image} src={image.src} fit />
        <Container className={styles.textImage}>
          <Text className={styles.title} body={title} />
          <Container className={styles.ctaContainer}>
            <Text className={styles.ctaLabel} body={ctaLabel} />
            <Arrow className={styles.arrow} />
          </Container>
        </Container>
      </LinkedComponent>
    </Container>
  );
};

type SimpleCardContainerProps = {
  data: SimpleCardContainer;
};
